<template>
  <div>
    <CPageTitle 
      :label="$t('subPlacementTitle')" 
      :subLabel="$t('subPlacementSubTitle')"
    ></CPageTitle>

    <div class="row main-content no-header no-footer">
      <div class="col-8">
        <CSubVisualisation
          v-if="(idx && idx > 0) || idx === 0"
          :idx="idx"
          :withScales=withScales
          :currentWidth="currentWidth"
          :currentHeight="currentHeight"
          :RoomInstance="RoomInstance"
          :unit="unit"
          @mouseenter="handleContextualHelpChanged('sub_visu')"
          @mouseleave="handleContextualHelpChanged(-1)"
        ></CSubVisualisation>

        <div v-else-if="idx === -1" style="margin-top: 34vh; height: 20vh">{{ $t('idx-1') }}</div>
        <div v-else-if="idx === -2" style="margin-top: 34vh; height: 20vh">{{ $t('idx-2') }}</div>

        <div v-if="((contextualHelp !== 'idx_visu' &&  contextualHelp !== -1) || (contextualHelp === 'idx_visu' && idx !== -1))" id="sub_placement_help" class="help-zone">
          <div class="help-title text-left ml-2">{{ renderContextualHelpTitle }}</div>
          <div v-if="contextualHelp !== 'idx_visu'" class="text-left ml-2">
            {{ renderContextualHelp }}
          </div>
          <div v-else class="text-left ml-2">
            {{ renderContextualHelp }}
            {{ renderContextualHelpLayout }}.
            <br />
            {{ renderContextualHelpBorder }}
          </div>
        </div>
      </div>
      <div class="col-4">
        <CSettings
          :idx="idx"
          :currentWidth="currentWidth"
          :currentHeight="currentHeight"
          :withScales="withScales"
          :unit=unit
          @RoomSizeChanged="handleRoomSizeChanged"
          @WithScalesChanged="handleWithScalesChanged"
          @ContextualHelpChanged="handleContextualHelpChanged"
          @UnitChanged="handleUnitChanged"
        ></CSettings>
      </div>
    </div>
  </div>
</template>

<script>
import CPageTitle from "@/lib/tui/components/titles/CPageTitle.vue";
import CSubVisualisation from "@/components/subPlacement/CSubVisualisation.vue";
import CSettings from "@/components/subPlacement/CSettings.vue";
import { Room } from "../../../shared/Room.js";
export default {
  name: "VSubPlacement",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  components: {
    CPageTitle,
    CSettings,
    CSubVisualisation
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  mounted: async function() {
    this.RoomInstance = new Room(this.currentWidth, this.currentHeight);
    this.idx = this.RoomInstance.getIdx();
    this.isOnBorder = this.RoomInstance.getBorderBool();
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  data () {
    return {
      currentWidth: 700,
      currentHeight: 300,
      ds: 228,
      df: 257,
      withScales: true,
      idx: null,
      RoomInstance: null,
      contextualHelp: -1,
      isOnBorder: null,
      unit: "cm"
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  methods: {
    handleRoomSizeChanged: function(event) {
      this[event.id] = Math.ceil(event.value);
    },
    //////////////////////////////////////////////////////////////////
    handleWithScalesChanged: function(event) {
      this.withScales = event.value;
    },
    //////////////////////////////////////////////////////////////////
    handleContextualHelpChanged: function(event) {
      this.contextualHelp = event;
    },
    //////////////////////////////////////////////////////////////////
    handleUnitChanged: function(event) {
      this.unit = event;
    }
  },
  //////////////////////////////////////////////////////////////////
  computed: {
    renderContextualHelp: function() {
      return this.$t('contextualHelp_' + this.contextualHelp);
    },
    //////////////////////////////////////////////////////////////////
    renderContextualHelpTitle: function() {
      return this.$t('contextualHelpTitle_' + this.contextualHelp);
    },
    renderContextualHelpLayout: function() {
      return this.$t('contextualHelpLayout_' + this.idx);
    },
    renderContextualHelpBorder: function() {
      if (!this.isOnBorder) {
        return ""
      }
      return this.$t('contextualHelpBorder');
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  watch: {
    currentWidth: async function() {
      this.RoomInstance.updateRoomSize(this.currentWidth, this.currentHeight);
      this.idx = this.RoomInstance.getIdx();
      this.isOnBorder = this.RoomInstance.getBorderBool();
    },
    //////////////////////////////////////////////////////////////////
    currentHeight: async function() {
      this.RoomInstance.updateRoomSize(this.currentWidth, this.currentHeight);
      this.idx = this.RoomInstance.getIdx();
      this.isOnBorder = this.RoomInstance.getBorderBool();
    }
  }
}
</script>

<style lang="scss" scoped>
  @include setMainContent(82vh, false, false, 2vw);

  .main-content {
    overflow-y: hidden;
  }

  #sub_placement_help {
    width: 90%;
    margin-left: 5%;
    height: 20vh;
    margin-top: 5vh;
    overflow-y: hidden;
  }

  .help-zone {
    font-size: 1.8vh;
    .help-title {
      color: white;
    }
  }
</style>